import { useRef } from "react";

let customBackHandler: (() => void) | undefined;

export const setGlobalBackHandler = (fn: () => void) => {
    customBackHandler = fn;
};

export const clearGlobalBackHandler = () => {
    customBackHandler = undefined;
};

export const getGlobalBackHandler = () => customBackHandler;
